import axios from "axios"
import { Liquid } from 'liquidjs'
import { http } from '../utils/api'

const liquid = new Liquid()

export const renderLiquidTemplate = (template, context) => {
  let error = false;
  let response = null;

  try {
    response = liquid.parseAndRenderSync(template, context);
  } catch(e) {
    error = true;
    response = e.message;
  }

  return {
    success: !error,
    response: response
  }
};

export const renderAddressTemplate = (addressTemplate, address) => {
  let context = {
    first_name: address.first_name,
    last_name: address.last_name,
    address1: address.address1,
    address2: address.address2,
    address3: address.address3,
    address4: address.address4,
    company: address.company,
    city: address.city,
    province: address.province,
    country: address.country,
    zip: address.zip,
    tax_office_name: address.tax_office_name,
    tax_office_title: address.tax_office_title,
  };

  return renderLiquidTemplate(addressTemplate, context);
};

export const uploadFile = (file_param, file, callback) => {
  let formData = new FormData();
  formData.append(file_param, file);

  axios.patch('/shop.json', formData, {
    headers: {
      'Authorization': this.props.authToken,
      'Content-Type': 'multipart/form-data'
    }
  })
  .then(function (response) {
    callback(response)
  })
  .catch(function (error) {
    if (window.bugsnagClient) {
      window.bugsnagClient.notify(JSON.stringify(error.response) || error)
    }
  });
};

export const fullPageRedirect = (url, shopify_domain) => {
  if (window.top == window.self) {
    // If the current window is the 'parent', change the URL by setting location.href
    window.top.location.href = url;
  } else {
    // If the current window is the 'child', change the parent's URL with postMessage
    let normalizedLink = document.createElement('a');
    normalizedLink.href = url;

    let data = JSON.stringify({
      message: 'Shopify.API.remoteRedirect',
      data: {
        location: normalizedLink.href
      }
    });
    window.parent.postMessage(data, `https://${shopify_domain}`);
  }
};

export const getInvoiceType = (invoice_type) => {
  if (invoice_type == 'invoice') {
    return "Invoice"
  } else if(invoice_type == 'pro_forma') {
    return "Pro Forma Invoice"
  } else if(invoice_type == "credit_note") {
    return "Credit Note"
  } else if(invoice_type == "quote") {
    return "Quote"
  } else if(invoice_type == "custom") {
    return "Custom Invoice"
  } else {
    return "Invoice"
  }
}

export const productImageUrl = (product_image_url, size = '60x') => {
  if (!product_image_url) {
    return null;
  }

  let url = new URL(product_image_url);

  if (url.host === 'cdn.shopify.com') {
    let pathParts = url.pathname.split('.');
    let extension = pathParts.pop();

    url.pathname = `${pathParts.join('.')}_${size}.${extension}`;
  }

  if (!url) {
    return null;
  }

  return url.toString();
}

export const updateSettings = (params, callback = null) => {
  http.patch(`/api/setting.json`, params)
    .then(response => callback && callback(response))
    .catch(error => {
      if (window.bugsnagClient) {
        window.bugsnagClient.notify(JSON.stringify(error.response) || error)
      }
    });
};
